// Simple YouTube URL utilities

/**
 * Extract video ID from YouTube URL
 * Supports formats:
 * - https://www.youtube.com/watch?v=VIDEO_ID
 * - https://youtu.be/VIDEO_ID
 * - https://www.youtube.com/embed/VIDEO_ID
 */
export const extractVideoId = (url) => {
  if (!url) return null;
  
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
    /^([a-zA-Z0-9_-]{11})$/ // Direct video ID
  ];
  
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return match[1];
  }
  
  return null;
};

/**
 * Extract playlist ID from YouTube playlist URL
 */
export const extractPlaylistId = (url) => {
  if (!url) return null;
  const match = url.match(/[?&]list=([a-zA-Z0-9_-]+)/);
  return match ? match[1] : null;
};

/**
 * Generate YouTube thumbnail URL from video ID or URL
 */
export const getThumbnailUrl = (videoIdOrUrl) => {
  const videoId = videoIdOrUrl.length === 11 ? videoIdOrUrl : extractVideoId(videoIdOrUrl);
  if (!videoId) return null;
  return `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
};

/**
 * Get playlist thumbnail (uses first video in playlist)
 * Note: Without API, we can't get the actual first video from playlist
 * This is a placeholder - you should set thumbnail manually in course data
 */
export const getPlaylistThumbnail = (playlistUrl) => {
  // YouTube doesn't provide direct playlist thumbnail URLs
  // The playlist thumbnail is typically the first video's thumbnail
  // For now, return null - should be set manually in course data
  return null;
};
